/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { removeFileExtension } from '../../../../common/helpers/common.helpers';
import Audio from '../../../../common/components/audio/audio.component';
import './file-item.style.scss';

/**
 * Class representing the file item component.
 * @extends Component
 * */
class FileItem extends Component {

  /**
   * Removes the current file item.
   * */
  handleGoToFile = () => {
    const { file: { id }, onGoToFile } = this.props;

    onGoToFile(id);
  };

  /**
   * Bubble up the new selection state.
   * */
  handleChange = () => {
    const { file: { id, selected }, onCheckChange } = this.props;

    onCheckChange(id, !selected);
  };

  render() {
    const {
      file: {
        format,
        download_url: url,
        isUploading,
        name,
        selected,
      },
      hideGoToFile
    } = this.props;

    return (
      <div className="file-item clearfix">
        <div className="check">
          <input
            checked={selected}
            onChange={this.handleChange}
            type="checkbox"
          />
        </div>
        <div className={`name ${hideGoToFile ? 'grow' : ''}`} title={removeFileExtension(name)}>
          {removeFileExtension(name)}
        </div>
        <div className="audio-actions">
          <Audio format={format} url={url} isUploading={isUploading} />
        </div>
        {!hideGoToFile && (
          <div className="edit-actions">
            <button type="button" className="btn btn-link go-to" onClick={this.handleGoToFile}>
              <FontAwesomeIcon icon={faEllipsisH} size="lg" />
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default FileItem;

FileItem.propTypes = {
  file: PropTypes.shape({
    format: PropTypes.string,
    id: PropTypes.number,
    isUploading: PropTypes.bool,
    name: PropTypes.string,
  }).isRequired,
  hideGoToFile: PropTypes.bool.isRequired,
  onGoToFile: PropTypes.func.isRequired,
  onCheckChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/messages/dashboard/files-list/file-item/file-item.component.js